<template>
  <span class="font-bold text-indigo-700" v-if="unlimited"
    ><Icon icon="infinite"
  /></span>
  <span class="font-medium text-gray-800" v-else
    >{{ formatNumber(value)
    }}<span class="text-xs font-normal text-gray-600">{{
      perMonth ? '/month' : ''
    }}</span></span
  >
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { formatNumber } from '~/lib/services/helpers';
import Icon from '~/components/form/Icon.vue';

const props = withDefaults(
  defineProps<{ value: number; perMonth?: boolean }>(),
  {
    perMonth: undefined,
  },
);
const unlimited = computed(() => props.value === -1);
</script>
